module.exports = {"620502001":"大城街道","620502002":"七里墩街道","620502003":"东关街道","620502004":"中城街道","620502005":"西关街道","620502006":"石马坪街道","620502007":"天水郡街道","620502100":"玉泉镇","620502101":"太京镇","620502102":"藉口镇","620502103":"皂郊镇","620502104":"汪川镇","620502105":"牡丹镇","620502106":"关子镇","620502107":"平南镇","620502108":"天水镇","620502109":"娘娘坝镇","620502110":"中梁镇","620502111":"杨家寺镇","620502112":"齐寿镇","620502113":"大门镇","620502114":"秦岭镇","620502115":"华歧镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620502.json
// module id = 3046
// module chunks = 0